import fi from './images/favicon.ico';
import fiAt from './images/apple-touch-icon.png';
import fi16 from './images/favicon-16x16.png';
import fi32 from './images/favicon-32x32.png';
import logo from './images/logo.svg';
import asideCenterLogo from './images/asideCenterLogo.svg';
import bg from './images/bg.svg';

const profitianLabelOptions = {
  name: 'Profitian',
  altName: 'Profitian Finance',
  site: 'https://app.profitian-tech.com',
  supportEmail: 'support@profitian-tech.com',
  termsAndConditionLink: 'https://www.profitian.co.il/term-of-use',
  privacyLink: 'https://www.profitian.co.il/privacy-policy',
  fi,
  fiAt,
  fi16,
  fi32,
  title: 'Profitian Finance',
  theme: 'profitian',
  isSsoLogin: false,
  logo: {
    src: logo,
    alt: 'Profitian Finance logo',
  },
  asideCenterLogo: {
    src: asideCenterLogo,
    alt: 'Profitian Finance',
    style: {
      maxWidth: '100%',
    },
  },
  loginSlogan: '',
  asidePoweredBy: true,
  appStoreDownloadLink: null,
  playMarketDownloadLink: null,
  brand: {
    primary: {
      10: '#3333330A',
      20: '#33333333',
      40: '#33333380',
      60: '#333333CC',
      80: '#333333',
      90: '#1A1A1A',
      100: '#1A1A1A',
    },
    secondary: {
      10: '#E4FF000A',
      20: '#E4FF0033',
      40: '#E4FF0080',
      60: '#E4FF00CC',
      80: '#E4FF00',
      90: '#A2B900',
      100: '#A2B900',
    },
  },
  styles: {
    aside: {
      backgroundColor: '#333333',
      backgroundImage: `url(${bg})`,
    },
  },
};

export default profitianLabelOptions;
